import { render, staticRenderFns } from "./TypePathology.vue?vue&type=template&id=6cb5b161&"
import script from "./TypePathology.vue?vue&type=script&lang=js&"
export * from "./TypePathology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports